module.exports = __webpack_public_path__ + "static/img/iphone-shouye.0ff7f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/iphone-shouye.png
// module id = L9NA
// module chunks = 70